/**
 * DF Banuba button
 *
 * 1. Déplace le bloc « Virtual Try-on » de Banuba (colonne infos produit) dans la galerie,
 *    pour l'afficher en haut à gauche du visuel, sur ordinateur comme sur mobile.
 *    Le style de positionnement (classe .df-banuba-in-gallery) est injecté ici car le
 *    Custom CSS de la section produit est limité à 500 caractères et déjà presque plein.
 * 2. Masque le libellé « Default Shade » affiché par l'app Banuba sous chaque teinte
 *    dans la fenêtre d'essai (ce texte vient de l'app, pas du thème). Le script cherche
 *    aussi dans les shadow DOM ouverts et les iframes du même domaine.
 * Si le bloc Banuba est désactivé dans le thème, ce script ne fait rien.
 */
(function () {
  var BLOCK = '.product-info__block-item[data-block-id*="banuba_virtual_try_on"]';
  var TARGET = '.product-gallery__image-list > .relative';
  var CSS = '.df-banuba-in-gallery{position:absolute;top:.75rem;left:.75rem;z-index:3;width:auto;max-width:calc(100% - 1.5rem);margin:0!important}' +
    '.df-banuba-in-gallery .tint-button-custom{width:auto!important;display:inline-block}' +
    '.df-banuba-in-gallery,.df-banuba-in-gallery *{border-radius:0!important}';
  var HIDDEN_TEXT = /^\s*Default Shade\s*$/i;

  function addStyle() {
    if (document.getElementById('df-banuba-style')) return;
    var style = document.createElement('style');
    style.id = 'df-banuba-style';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function move() {
    document.querySelectorAll('.product').forEach(function (product) {
      var target = product.querySelector(TARGET);
      if (!target) return;
      product.querySelectorAll(BLOCK).forEach(function (block) {
        if (target.contains(block)) return;
        addStyle();
        block.classList.add('df-banuba-in-gallery');
        target.appendChild(block);
      });
    });
  }

  // Masque les éléments dont le texte est exactement « Default Shade »
  // (parcourt aussi les shadow DOM ouverts et les iframes accessibles)
  function hideShadeLabels(root) {
    if (!root) return;
    var doc = root.nodeType === 9 ? root : root.ownerDocument;
    if (!doc) return;
    var walker = doc.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) {
        if (HIDDEN_TEXT.test(node.nodeValue) && node.parentElement) {
          node.parentElement.style.display = 'none';
        }
      } else {
        if (node.shadowRoot) hideShadeLabels(node.shadowRoot);
        if (node.tagName === 'IFRAME') {
          try {
            if (node.contentDocument && node.contentDocument.body) hideShadeLabels(node.contentDocument.body);
          } catch (e) { /* iframe d'un autre domaine : inaccessible */ }
        }
      }
    }
  }

  function scanAll() {
    if (document.body) hideShadeLabels(document.body);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(move, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', move);
  } else {
    move();
  }

  // Changement de variante / re-rendu de la fiche produit
  document.addEventListener('product:rerender', function () { setTimeout(move, 200); });

  var root = document.querySelector('product-rerender');
  if (root && 'MutationObserver' in window) {
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  }

  // Fenêtre d'essai Banuba : injectée dans la page à l'ouverture
  if ('MutationObserver' in window) {
    var attach = function () {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType === 1) hideShadeLabels(n);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) attach();
    else document.addEventListener('DOMContentLoaded', attach);
  }

  // Après un clic (ouverture de la fenêtre, changement d'onglet…), on re-scanne
  // plusieurs fois car l'app charge son contenu en différé.
  document.addEventListener('click', function () {
    [300, 800, 1500, 3000].forEach(function (d) { setTimeout(scanAll, d); });
  }, true);
})();